/* AG Library shelf, token-aware ownership.
   Reads the access token (?key= or saved), carries it onto book links so the
   reader unlocks, and marks owned books "Owned / Read now" via /entitlements. */
(function () {
  "use strict";
  var CFG = window.AG_LIBRARY_CONFIG || {};

  // ── "Already purchased?" self-serve unlock, enter the purchase email, the
  //    Worker scans your paid orders, we save the returned token and reload the
  //    page unlocked. Runs for every visitor (the library is token-gated, not
  //    login-gated). ───────────────────────────────────────────────────────────
  (function () {
    var unlockBtn = document.querySelector("[data-agl-unlock]");
    var switchBtn = document.querySelector("[data-agl-switch]");
    if ((!unlockBtn && !switchBtn) || !CFG.claimUrl) return;
    // Already signed in (saved token / ?key=)? Show "Use a different email" so a
    // shared device / wrong-email buyer can switch account; otherwise show the
    // "Already purchased?" unlock.
    var signedIn = false;
    try { signedIn = !!(new URLSearchParams(location.search).get("key") || localStorage.getItem("ag_library_token")); } catch (e) {}
    if (unlockBtn) unlockBtn.hidden = signedIn;
    if (switchBtn) switchBtn.hidden = !signedIn;
    function promptClaim(btn) {
      var email = window.prompt("Enter the email you bought with. We'll unlock your books:");
      if (!email) return;
      var orig = btn.innerHTML;
      btn.textContent = "Checking…"; btn.disabled = true;
      fetch(CFG.claimUrl, {
        method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ email: email })
      }).then(function (r) { if (!r.ok) throw new Error("claim HTTP " + r.status); return r.json(); })
        .then(function (d) {
          if (d && d.token && d.books && d.books.length) {
            try { localStorage.setItem("ag_library_token", d.token); } catch (e) {}
            var u = new URL(window.location.href);
            u.searchParams.set("key", d.token);   // overwrites any current key → switches account cleanly
            window.location.href = u.toString();
          } else {
            btn.disabled = false; btn.innerHTML = orig;
            window.alert("We couldn't find a purchase for that email. Check the address you ordered with.");
          }
        })
        .catch(function () { btn.disabled = false; btn.innerHTML = orig; window.alert("Sorry, something went wrong, please try again."); });
    }
    if (unlockBtn) unlockBtn.addEventListener("click", function () { promptClaim(unlockBtn); });
    if (switchBtn) switchBtn.addEventListener("click", function () { promptClaim(switchBtn); });
  })();

  // ── Entry unlock popup, on first visit (no saved token), prompt for the
  //    purchase email; on submit, claim + cache the token + reload unlocked.
  //    Shows once (until dismissed/unlocked); the "Already purchased?" button
  //    remains available afterwards. ──────────────────────────────────────────
  (function () {
    var modal = document.querySelector("[data-agl-modal]");
    if (!modal || !CFG.claimUrl) return;
    var haveToken = false, seen = false;
    try { haveToken = !!(new URLSearchParams(location.search).get("key") || localStorage.getItem("ag_library_token")); } catch (e) {}
    try { seen = !!localStorage.getItem("ag_library_unlock_seen"); } catch (e) {}

    function openModal() {
      modal.hidden = false; modal.setAttribute("aria-hidden", "false");
      modal.offsetHeight; modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
      var inp = modal.querySelector("input[name=email]");
      setTimeout(function () { try { if (inp) inp.focus(); } catch (e) {} }, 260);
    }
    function closeModal() {
      modal.classList.remove("is-open");
      document.body.style.overflow = "";
      try { localStorage.setItem("ag_library_unlock_seen", "1"); } catch (e) {}
      setTimeout(function () { modal.hidden = true; modal.setAttribute("aria-hidden", "true"); }, 260);
    }
    if (!haveToken && !seen) setTimeout(openModal, 650);

    [].slice.call(modal.querySelectorAll("[data-agl-modal-close]")).forEach(function (el) {
      el.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) closeModal();
    });

    var form = modal.querySelector("[data-agl-modal-form]");
    var err = modal.querySelector("[data-agl-modal-err]");
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var inp = form.querySelector("input[name=email]");
      var email = ((inp && inp.value) || "").trim();
      if (!email) return;
      var sub = form.querySelector("button[type=submit]");
      var origTxt = sub ? sub.textContent : "";
      if (sub) { sub.textContent = "Checking…"; sub.disabled = true; }
      if (err) { err.hidden = true; err.textContent = ""; }
      fetch(CFG.claimUrl, {
        method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ email: email })
      }).then(function (r) { if (!r.ok) throw new Error("claim HTTP " + r.status); return r.json(); })
        .then(function (d) {
          if (d && d.token && d.books && d.books.length) {
            try { localStorage.setItem("ag_library_token", d.token); localStorage.setItem("ag_library_unlock_seen", "1"); } catch (e) {}
            var u = new URL(location.href); u.searchParams.set("key", d.token);
            location.href = u.toString();
          } else {
            if (sub) { sub.textContent = origTxt; sub.disabled = false; }
            if (err) { err.textContent = "We couldn't find a purchase for that email. Check the address you ordered with, or browse below."; err.hidden = false; }
          }
        })
        .catch(function () {
          if (sub) { sub.textContent = origTxt; sub.disabled = false; }
          if (err) { err.textContent = "Sorry, something went wrong, please try again."; err.hidden = false; }
        });
    });
  })();

  // ── category filter chips, runs for EVERY visitor (must be before the
  //    token/ownership early-returns below, or it never wires up). ───────────
  (function () {
    var chips = [].slice.call(document.querySelectorAll(".agl-chip"));
    if (!chips.length) return;
    var books = [].slice.call(document.querySelectorAll(".agl-book"));
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-on"); });
        chip.classList.add("is-on");
        var cat = chip.getAttribute("data-cat");
        books.forEach(function (li) {
          var lc = li.getAttribute("data-category") || "";
          li.style.display = (cat === "*" || lc === cat) ? "" : "none";
        });
      });
    });
  })();

  function qp(n) { try { return new URLSearchParams(location.search).get(n); } catch (e) { return null; } }
  var token = "";
  var k = qp("key");
  if (k) { token = k; try { localStorage.setItem("ag_library_token", k); } catch (e) {} }
  else { try { token = localStorage.getItem("ag_library_token") || ""; } catch (e) {} }

  var links = [].slice.call(document.querySelectorAll(".agl-book-link[data-book-id]"));
  if (!links.length) return;

  // carry the token onto every book link so the reader opens unlocked
  if (token) {
    links.forEach(function (a) {
      var u = a.getAttribute("href");
      if (u && u.indexOf("key=") === -1) {
        a.setAttribute("href", u + (u.indexOf("?") >= 0 ? "&" : "?") + "key=" + encodeURIComponent(token));
      }
    });
  }

  if (!token || !CFG.entUrl) return;

  var url = CFG.entUrl + (CFG.entUrl.indexOf("?") >= 0 ? "&" : "?") + "token=" + encodeURIComponent(token);
  fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
    if (!d || !d.books) return;
    var owned = d.books;
    links.forEach(function (a) {
      if (owned.indexOf(a.getAttribute("data-book-id")) === -1) return;
      var li = a.closest(".agl-book"); if (li) li.classList.add("is-owned");
      var cover = a.querySelector(".agl-cover");
      var badge = a.querySelector(".agl-badge");
      if (!badge && cover) { badge = document.createElement("span"); cover.appendChild(badge); }
      if (badge) { badge.className = "agl-badge agl-badge--owned"; badge.textContent = "Owned"; }
      var cta = a.querySelector(".agl-cta");
      if (cta) { cta.className = "agl-cta agl-cta--read"; cta.textContent = "Owned"; }
    });
  }).catch(function () {});
})();
